if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector('.image-comparison-slider__container');
        this.handle = this.querySelector('.image-comparison-slider__handle');
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        if (!this.container || !this.handle) return;
        this.container.addEventListener('pointerdown', this.onPointerDown);
        this.handle.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        this.container.removeEventListener('pointerdown', this.onPointerDown);
        this.handle.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
      }

      onPointerDown(event) {
        this.dragging = true;
        this.updateFromPointer(event);
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp, { once: true });
        this.handle.focus({ preventScroll: true });
      }

      onPointerMove(event) {
        if (!this.dragging) return;
        this.updateFromPointer(event);
      }

      onPointerUp() {
        this.dragging = false;
        window.removeEventListener('pointermove', this.onPointerMove);
      }

      updateFromPointer(event) {
        const rect = this.container.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const percent = Math.min(100, Math.max(0, (x / rect.width) * 100));
        this.setPosition(percent);
      }

      onKeyDown(event) {
        const current = parseFloat(this.container.style.getPropertyValue('--position')) || 50;
        const step = event.shiftKey ? 10 : 2;
        let next = current;

        if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
          next = current - step;
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
          next = current + step;
        } else if (event.key === 'Home') {
          next = 0;
        } else if (event.key === 'End') {
          next = 100;
        } else {
          return;
        }

        event.preventDefault();
        this.setPosition(Math.min(100, Math.max(0, next)));
      }

      setPosition(percent) {
        const rounded = Math.round(percent * 10) / 10;
        this.container.style.setProperty('--position', `${rounded}%`);
        this.handle.setAttribute('aria-valuenow', Math.round(rounded));
      }
    }
  );
}